import { render, staticRenderFns } from "./bindPage.vue?vue&type=template&id=543cf518&scoped=true&"
import script from "./bindPage.vue?vue&type=script&lang=js&"
export * from "./bindPage.vue?vue&type=script&lang=js&"
import style0 from "./bindPage.vue?vue&type=style&index=0&id=543cf518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543cf518",
  null
  
)

export default component.exports